import lazyLoadView from './lazy-load-view'

export default [
  {
    path: '/',
    name: 'index',
    // component: () => lazyLoadView(import('@views/home')),
    redirect: {
      name: 'property-landing',
      params: { permalink: 'kamandalu' },
    },
  },
  {
    path: '/properties/:permalink',
    component: () => lazyLoadView(import('@layouts/master')),
    meta: {
      beforeResolve: require('../guards/property').default,
    },
    props: ({ params }) => ({
      layout: params.layout,
      layoutComponents: params.layoutComponents,
      property: params.property,
    }),
    children: [
      {
        path: '',
        name: 'property-landing',
        component: () => lazyLoadView(import('@views/landing')),
        meta: {
          beforeResolve: require('../guards/rooms').default,
        },
        props: ({ params }) => ({ property: params.property }),
      },
      {
        path: 'extras',
        name: 'property-extras',
        component: () => lazyLoadView(import('@views/extras')),
        meta: {
          beforeResolve: require('../guards/extras').default,
        },
        props: ({ params }) => ({ property: params.property }),
      },
      {
        path: 'booking',
        name: 'property-booking',
        // component: () => lazyLoadView(import('@views/booking')),
        components: {
          default: () => lazyLoadView(import('@views/booking')),
          bottom: () => lazyLoadView(import('@components/policies-modal')),
        },
        meta: {
          beforeResolve: require('../guards/booking').default,
        },
        props: {
          default: ({ params }) => ({
            property: params.property,
            dropdown: params.dropdown,
          }),
        },
      },
      {
        path: 'booking-confirmation',
        name: 'booking-confirmation',
        component: () => lazyLoadView(import('@views/booking-confirmation')),
        meta: {
          beforeResolve: require('../guards/booking-confirmation').default,
        },
        props: ({ params }) => ({ property: params.property }),
      },
      {
        path: 'web-checkin',
        name: 'web-checkin',
        component: () => lazyLoadView(import('@views/web-checkin')),
        meta: {
          beforeResolve: require('../guards/web-checkin').default,
        },
        props: ({ params }) => ({
          property: params.property,
          alert: params.alert,
        }),
      },
      {
        path: 'web-checkin/details',
        name: 'web-checkin-details',
        component: () => lazyLoadView(import('@views/web-checkin-details')),
        meta: {
          beforeResolve: require('../guards/web-checkin-details').default,
        },
        props: ({ params }) => ({
          property: params.property,
          reservation: params.reservation,
          dropdown: params.dropdown,
        }),
      },
    ],
  },
]
